import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowLeft, PencilRuler, Phone } from 'lucide-react'
import { Container } from '@/components/generals/container'
import { buttonVariants } from '@/components/ui/button'
import { contactInfo } from '@/constants/site'

export const CtaBanner: FC = (): ReactNode => {
    return (
        <section aria-labelledby='custom-order-cta-title' className='pb-20 lg:pb-28'>
            <Container>
                <div className='flex flex-col gap-8 rounded-[2rem] border border-border bg-card p-8 sm:p-12 lg:flex-row lg:items-center lg:justify-between'>
                    <div className='flex gap-5'>
                        <span className='hidden size-14 shrink-0 items-center justify-center rounded-2xl bg-accent text-brand sm:flex'>
                            <PencilRuler className='size-6' aria-hidden='true' />
                        </span>

                        <div>
                            <h2 id='custom-order-cta-title' className='font-heading text-3xl font-semibold leading-snug text-foreground sm:text-4xl'>
                                چیزی که دنبالش هستید را پیدا نکردید؟
                            </h2>

                            <p className='mt-3 max-w-2xl text-base leading-8 text-muted-foreground'>
                                تقریباً هر محصولی را می‌توانیم در ابعاد، رنگ و پارچهٔ دلخواه شما بسازیم. ایده یا عکس موردنظرتان را برای ما بفرستید.
                            </p>
                        </div>
                    </div>

                    <div className='flex shrink-0 flex-wrap gap-3'>
                        <Link href='/contact' className={buttonVariants({ size: 'lg' })}>
                            سفارش اختصاصی
                            <ArrowLeft aria-hidden='true' />
                        </Link>

                        <a href={contactInfo.phoneHref} className={buttonVariants({ variant: 'outline', size: 'lg' })}>
                            <Phone aria-hidden='true' />
                            <span dir='ltr'>
                                {contactInfo.phone}
                            </span>
                        </a>
                    </div>
                </div>
            </Container>
        </section>
    )
}
